import styled from "styled-components";
import { generateLatest7DaysOfWeekWithoutToday } from "../../utils/generateLatestSevenDays";
import { useState, useEffect } from "react";
const Tmp = styled.div`
  margin-top: -25px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 21px;
`;
const ChartDateOfWeek = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const arr = generateLatest7DaysOfWeekWithoutToday();
    for (let i = arr?.length - 1; i >= 0; i--) {
      setData(current => [...current, (<span key={arr[i]} className="text-[10px] font-bold">({arr[i]})</span>)]);
    }
  }, []);
  return (
    <Tmp>
      {data}
    </Tmp>
  );
};

export default ChartDateOfWeek;
